import { Sparkles } from 'lucide-react';
import { Badge } from '@/shared/components/ui/Badge';
import { cn } from '@/shared/utils/utils';

/**
 * The single, consistent marker that labels a copilot output as a
 * non-authoritative `AI_Suggestion`, distinguishable from persisted CRM data
 * (Req 9.4, 10.3, 14.3). Use the badge inline on any AI-produced value.
 */
export function AISuggestionBadge({ className }: { className?: string }) {
  return (
    <Badge tone="info" className={cn('gap-1', className)}>
      <Sparkles className="h-3 w-3" aria-hidden />
      AI Suggestion
    </Badge>
  );
}

/**
 * Class applied to any card/section that wholly consists of an AI suggestion —
 * a colored ring visually separates it from persisted-data surfaces (Req 14.3).
 */
export const AI_SUGGESTION_RING = 'ring-2 ring-info/50';
